var map = {
	"./AJK Board.png": "7c38",
	"./Federal Board.png": "f948",
	"./KPK Boards.png": "7425",
	"./Punjab Boards.png": "f431",
	"./computer.png": "c385",
	"./error.png": "cd92",
	"./ic_discussion.png": "ec38",
	"./ic_lecture.png": "ec7c",
	"./ic_test.png": "142b",
	"./ic_worksheet.png": "c50a",
	"./teams.png": "9239"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a451";